<div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 px-4 text-center">
  <h1 class="text-7xl font-bold text-primary-600 mb-4">404</h1>
  <p class="text-2xl text-gray-800 mb-6">Sorry, the page you are looking for does not exist.</p>
  <a
    [routerLink]="'/'"
    class="px-6 py-2 text-white bg-blue-600 rounded hover:bg-blue-700 transition"
  >
    Go to Homepage
  </a>
</div>
